/* eslint-disable react/jsx-one-expression-per-line */
import {
  AlertOutlined,
  AppstoreOutlined,
  CalendarOutlined,
  FileOutlined,
  LoadingOutlined,
  MailOutlined,
  PhoneOutlined,
  PicLeftOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Avatar, Card, Col, Divider, Flex, Row, Tag, Typography } from 'antd'
import { format } from 'date-fns'
import React from 'react'
import { useTicket } from '~/hooks/HelpDesk/useTickets'
import { translate } from '~/utils/locale'

const DetailsTicket: React.FC = () => {
  const { ticket, isLoading } = useTicket()

  if (isLoading || !ticket) {
    return <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
  }

  const { Title, Text } = Typography

  const createdTicket = format(
    new Date(ticket.createdAt),
    `dd/MM/yyyy '${translate('TasksTabsDetails.dateString')}' HH:mm'h'`,
  )

  const dateTicket = format(
    new Date(ticket.date),
    `dd/MM/yyyy '${translate('TasksTabsDetails.dateString')}' HH:mm'h'`,
  )

  return (
    <>
      <Row gutter={10}>
        <Col span={14}>
          <Card
            bordered={false}
            title={
              <Flex align="center" justify="space-between">
                <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
                  {translate('ClientsDetailsTab.cardGeneralInfoTitle')}
                </Title>
                {ticket.status === 'new' ? <Tag color="#1565C0">Novo</Tag> : ''}

                {ticket.status === 'working' ? (
                  <Tag color="#6A1B9A">Em Atendimento</Tag>
                ) : (
                  ''
                )}

                {ticket.status === 'completed' ? (
                  <Tag color="#439A5F">Concluído</Tag>
                ) : (
                  ''
                )}

                {ticket.status === 'canceled' ? (
                  <Tag color="#616161">Cancelado</Tag>
                ) : (
                  ''
                )}
              </Flex>
            }
            style={{
              display: 'inline-block',
              width: '100%',
            }}
          >
            <>
              <Row>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <FileOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        Título do Ticket
                      </Title>
                      <Text>{ticket.title}</Text>
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <CalendarOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskDetailTab.createdAtLabel')}
                      </Title>
                      <Text>{createdTicket}</Text>
                    </div>
                  </Flex>
                </Col>
              </Row>

              <Row style={{ marginTop: 14 }}>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <CalendarOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskDetailTab.date')}
                      </Title>
                      <Text>{dateTicket}</Text>
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <AlertOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskDetailTab.priorityLabel')}
                      </Title>
                      {ticket.priority ? (
                        <>
                          {ticket.priority === 'low' ? (
                            <Tag color="#53C176">Baixa</Tag>
                          ) : (
                            ''
                          )}
                          {ticket.priority === 'medium' ? (
                            <Tag color="#00838F">Média</Tag>
                          ) : (
                            ''
                          )}
                          {ticket.priority === 'high' ? (
                            <Tag color="#D04141">Alta</Tag>
                          ) : (
                            ''
                          )}
                        </>
                      ) : (
                        'Nenhuma informação disponível.'
                      )}
                    </div>
                  </Flex>
                </Col>
              </Row>

              <Row style={{ marginTop: 14 }}>
                <Col span={24}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <PicLeftOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskDetailTab.descriptionTitle')}
                      </Title>
                      <Text>
                        {ticket.description ? (
                          <>{ticket.description}</>
                        ) : (
                          'Nenhuma informação disponível.'
                        )}
                      </Text>
                    </div>
                  </Flex>
                </Col>
              </Row>
            </>

            <Divider style={{ margin: '14px 0' }} />
            <Title level={5}>
              {translate('HelpDeskDetailTab.typeRequestLabel')}
            </Title>

            <Row>
              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <AppstoreOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('HelpDeskDetailTab.typeRequestTitle')}
                    </Title>
                    <Text>
                      {ticket?.ticketType?.title ? (
                        <>{ticket?.ticketType?.title}</>
                      ) : (
                        'Nenhuma informação disponível.'
                      )}
                    </Text>
                  </div>
                </Flex>
              </Col>

              <Col span={12}>
                <Flex gap={10}>
                  <Avatar
                    shape="square"
                    icon={
                      <PicLeftOutlined
                        style={{ fontSize: 12, color: '#464545' }}
                      />
                    }
                    size="small"
                    style={{ background: '#DADADA' }}
                  />
                  <div>
                    <Title level={5} style={{ marginBottom: 0 }}>
                      {translate('HelpDeskDetailTab.typeRequestDescription')}
                    </Title>
                    <Text>
                      {ticket?.ticketType?.description ? (
                        <>{ticket?.ticketType?.description}</>
                      ) : (
                        'Nenhuma informação disponível.'
                      )}
                    </Text>
                  </div>
                </Flex>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={10}>
          <Card
            bordered={false}
            title={
              <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
                {translate('HelpDeskClientTab.clientTabTitle')}
              </Title>
            }
            style={{
              display: 'inline-block',
              width: '100%',
            }}
          >
            <>
              <Row>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <UserOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskClientTab.clientLabel')}
                      </Title>
                      <Text>{ticket.customer}</Text>
                    </div>
                  </Flex>
                </Col>

                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <MailOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskClientTab.emailLabel')}
                      </Title>
                      <Text> {ticket.customer_email}</Text>
                    </div>
                  </Flex>
                </Col>
              </Row>
              <Row style={{ marginTop: 14 }}>
                <Col span={12}>
                  <Flex gap={10}>
                    <Avatar
                      shape="square"
                      icon={
                        <PhoneOutlined
                          style={{ fontSize: 12, color: '#464545' }}
                        />
                      }
                      size="small"
                      style={{ background: '#DADADA' }}
                    />
                    <div>
                      <Title level={5} style={{ marginBottom: 0 }}>
                        {translate('HelpDeskClientTab.telephoneLabel')}
                      </Title>
                      <Text>
                        {ticket.customer_phone !== 'undefined' ? (
                          <>{ticket.customer_phone}</>
                        ) : (
                          'Nenhum telefone fornecido'
                        )}
                      </Text>
                    </div>
                  </Flex>
                </Col>
              </Row>
            </>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default DetailsTicket
